import React from 'react';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';

import { fetchRecoDetails } from '../../../dataFetchers/recoDataFetcher';
import BCLLoading from '../../common/Loading/BCLLoading';
import RecoDetails from './RecoDetails';
import { fetchingRecoDetails } from '../../../actions/recoDetailsActions';
import { getBECompatibleLocale } from '../../../helpers/helper';
import { isPreview } from '../../../helpers/authHelper';
import { WIDGETS } from '../../../constants/common';
import { getPilotId } from '../../../helpers/userHelper';

class RecoDetailsContainer extends React.Component {
    componentDidMount(){
        if(!this.props.recoDetailsData.recoDetails || !this.props.recoDetailsData.recoDetails[this.props.activeReco]){
            this.props.fetchingDetails();
            let options = {
                isPublic: this.props.isPublic,
                recoId: this.props.activeReco,
                locale: getBECompatibleLocale(this.props.configData),
                pilotId: getPilotId()
            };
            if (this.props.userIdentityDetails) {
                options['userId'] = this.props.userIdentityDetails.userId;
            }
            if (isPreview()) {
                options['templateName'] = `${WIDGETS.RECOMMENDATIONS}.FETCH_RECO_DETAILS`;
            }
            this.props.fetchRecoDetails(options);
        }
    }

    render(){
        let {recoDetailsData} = this.props;
        return(
            <div className="reco-details">
                { !this.props.hideClose && !recoDetailsData.fetching &&
                    <div className="reco-details-close">
                        <CloseIcon classes={{ root: "close-icon" }} onClick={this.props.onCloseClick} />
                    </div>
                }
                {(!recoDetailsData.fetching && recoDetailsData.recoDetails && recoDetailsData.recoDetails[this.props.activeReco]) ?
                <RecoDetails data={recoDetailsData.recoDetails[this.props.activeReco]}
                activeReco={this.props.activeReco} onRecoLike={(recoID) => this.onRecoLike(recoID)} onRecoUnlike={(recoID) => this.onRecoUnlike(recoID)} translations={this.props.translations}
                ctaEnabled={this.props.marketplaceCTAEnabled} openPurchaseLink={(itemLink)=>this.props.openPurchaseLink(itemLink)} applianceList={this.props.applianceList}/> :
                recoDetailsData.fetching ? <BCLLoading/> : ''}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userIdentityDetails: state.userIdentityDetails,
    configData : state.configs.data,
    translations: state.translationsData.data,
    recoDetailsData : state.recoDetailsData,
    applianceList: state.appliances.appliancesList
})

const mapDispatchToProps = dispatch => {
    return{
        fetchRecoDetails : (options) => dispatch(fetchRecoDetails(options)),
        fetchingDetails : () => dispatch(fetchingRecoDetails())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(RecoDetailsContainer);

